import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Link,
  Checkbox,
  FormControlLabel,
  Collapse,
  FormControl,
  RadioGroup, Radio
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  obtenerDatosHotel,
  leerParametroURL,
  enctriptoParaAdmintour,
} from "../../services/motorService";
import RoomTypeRatePlanContext from "../contexts/RoomTypeRatePlanContext";
import webpay from "./webpay1.png";
import compraaqui from "./compraaqui.png";
import redPagosLogo from "./logosSistarbanc/redPagos.png";
import hsbcLogo from "./logosSistarbanc/hsbc.png";
import bandesLogo from "./logosSistarbanc/bandes.webp";
import bbvaLogo from "./logosSistarbanc/bbva.avif";
import brouLogo from "./logosSistarbanc/brou.png";
import heritageLogo from "./logosSistarbanc/heritage.jpeg";
import itauLogo from "./logosSistarbanc/itau.svg";
import santanderLogo from "./logosSistarbanc/santander.png";
import ocaLogo from "./logosSistarbanc/OCA.webp";
import prexLogo from "./logosSistarbanc/prex.webp";
import visaLogo from "./logosSistarbanc/visa.webp";
import passcardLogo from "./logosSistarbanc/passcard.png";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import useSession from "../../services/session";
import CheckoutContext from "../contexts/CheckoutContext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useTheme, useMediaQuery } from "@mui/material";

// -----------------------------------------------------------------------
// LOGOS de los medios de pago personalizados (AEBU, hoteles 30/31).
// Los archivos reales están en src/components/payment/logosSistarbanc/.
// Si algún código no tiene entrada acá (o el import fallara), esa opción
// puntual cae automáticamente a una "chip" de color sólido con el nombre
// (ver BRAND_COLORS más abajo), así nunca queda una opción vacía/rota.
// -----------------------------------------------------------------------
const PAYMENT_LOGOS = {
  "1": redPagosLogo, // Red Pagos
  "157": hsbcLogo, // HSBC
  "110": bandesLogo, // BANDES
  "153": bbvaLogo, // BBVA
  "001": brouLogo, // BROU
  "216": heritageLogo, // HERITAGE
  "113": itauLogo, // ITAÚ
  "137": santanderLogo, // SANTANDER
  "1108": ocaLogo, // OCA
  "1119": prexLogo, // Prex
  "1110": visaLogo, // Visa
  "1109": passcardLogo, // PassCard
};

// Colores de respaldo: solo se usan si algún código quedara sin logo
// (por ejemplo, si en el futuro sumás un medio de pago nuevo antes de
// conseguirle el logo).
const BRAND_COLORS = {
  "1": "#00A65D", // Red Pagos
  "157": "#DB0011", // HSBC
  "110": "#0033A0", // BANDES
  "153": "#004481", // BBVA
  "001": "#00539F", // BROU
  "216": "#2C2C2C", // HERITAGE
  "113": "#EC7000", // ITAÚ
  "137": "#EC0000", // SANTANDER
  "1108": "#F7941E", // OCA
  "1119": "#6C2EB5", // Prex
  "1110": "#1A1F71", // Visa
  "1109": "#00838F", // PassCard
};
const DEFAULT_BRAND_COLOR = "#616161";

// Algunos de los archivos de logosSistarbanc/ traen el isotipo bien
// recortado (Visa, Prex, PassCard, Red Pagos) y otros vienen con bastante
// aire/padding blanco alrededor del isotipo dentro de la propia imagen
// (Bandes, BBVA, Banco República, Banque Heritage, HSBC, Itaú, Santander,
// OCA), así que a igual "height" en la tarjeta se ven mucho más chicos.
// Este factor amplía (con zoom, recortando el excedente) solo esos logos
// para que todos ocupen un espacio visual parecido. Se puede retocar
// número por número si alguno queda muy ajustado o se sigue viendo chico.
const LOGO_ZOOM = {
  "1": 1, // Red Pagos
  "157": 1.35, // HSBC
  "110": 1.35, // BANDES
  "153": 1.3, // BBVA
  "001": 1.7, // BROU / Banco República
  "216": 1.15, // HERITAGE (es un logo apaisado; con más zoom se corta "TAGE")
  "113": 1.2, // ITAÚ
  "137": 1.9, // SANTANDER
  "1108": 1.9, // OCA
  "1119": 1, // Prex
  "1110": 1, // Visa
  "1109": 1.1, // PassCard
};

// group: se usa para la lógica de negocio (ej. Checkout.js antepone
// "A PAGAR EN RED PAGOS" en las observaciones cuando group === "RED_COBRANZA").
// category: solo se usa para agrupar visualmente el selector en 3 secciones.
const CUSTOM_PAYMENT_OPTIONS = {
  "30": [
    { code: "1", label: "Red Pagos", group: "RED_COBRANZA", category: "redes_cobranza" },
    { code: "157", label: "HSBC", group: "TARJETA_BANCO", category: "bancos" },
  ],
  "31": [
    { code: "1", label: "Red Pagos", group: "RED_COBRANZA", category: "redes_cobranza" },
    { code: "110", label: "BANDES", group: "TARJETA_BANCO", category: "bancos" },
    { code: "153", label: "BBVA", group: "TARJETA_BANCO", category: "bancos" },
    { code: "001", label: "BROU", group: "TARJETA_BANCO", category: "bancos" },
    { code: "216", label: "HERITAGE", group: "TARJETA_BANCO", category: "bancos" },
    { code: "157", label: "HSBC", group: "TARJETA_BANCO", category: "bancos" },
    { code: "113", label: "ITAÚ", group: "TARJETA_BANCO", category: "bancos" },
    { code: "137", label: "SANTANDER", group: "TARJETA_BANCO", category: "bancos" },
    { code: "1108", label: "OCA", group: "TARJETA_BANCO", category: "tarjetas" },
    { code: "1119", label: "Prex", group: "TARJETA_BANCO", category: "tarjetas" },
    { code: "1110", label: "Visa", group: "TARJETA_BANCO", category: "tarjetas" },
    { code: "1109", label: "PassCard", group: "TARJETA_BANCO", category: "tarjetas" },
  ],
};

const PAYMENT_CATEGORY_ORDER = ["redes_cobranza", "bancos", "tarjetas"];
const PAYMENT_CATEGORY_LABELS = {
  redes_cobranza: "Redes de cobranza",
  bancos: "Bancos",
  tarjetas: "Tarjetas",
};

const Payment = ({
  aceptaTerminosTransferencia,
  setAceptaTerminosTransferencia,
  onBeforeWebpay,
}) => {
  const [tarjetaEnGarantia, setTarjetaEnGarantia] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const hotcodParam = params.get("hotcod");
  const hotCod = hotcodParam ?? Cookies.get("hotCod") ?? null;
  const valorT = params.get("t");

  const [datosHotel, setDatosHotel] = useState({});
  const navigate = useNavigate();
  const [transactionLoading, setTransactionData] = useState(false);
  const { cartItems } = useContext(RoomTypeRatePlanContext);
  const { formValues, setFormValues } = useContext(CheckoutContext);
  const session = useSession();
  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  const [mostrarNormas, setMostrarNormas] = useState(false);
  const [mostrarDatosPersonales, setMostrarDatosPersonales] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [creating, setCreating] = useState(false);
  const [tipoPagoGarantiaB, setTipoPagoGarantiaB] = useState(""); //banco estado

  const customPaymentOptions = CUSTOM_PAYMENT_OPTIONS[String(hotCod)] || null;
  const usaMetodoPagoPersonalizado = Boolean(customPaymentOptions);

  const aceptaTransferencia =
    datosHotel.transferencia === "S" ||
    Boolean(datosHotel.Banco || datosHotel.CuentaBanco || datosHotel.aliascuenta);

  const paisHotelNormalizado = String(
    datosHotel?.MotorHotPais ||
    datosHotel?.HotelPaisCodigo ||
    datosHotel?.Pais ||
    datosHotel?.PaisCodigo ||
    datosHotel?.MotorHotPaisNombre ||
    ""
  )
    .trim()
    .toUpperCase();

  const esHotelChile =
    paisHotelNormalizado === "CHILE" ||
    paisHotelNormalizado === "CL" ||
    paisHotelNormalizado === "56";

  useEffect(() => {
    const getData = async () => {
      try {
        const data = await obtenerDatosHotel(hotCod);
        setDatosHotel(data);
        setTarjetaEnGarantia(data.MotorHotSolTarjeta);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching hotel data:", error);
      }
    };
    getData();
  }, [hotCod]);

  /*const totalImporte = cartItems
    ? cartItems.reduce(
        (total, item) => total + parseFloat(item.CarritoItemTotal || 0),
        0
      )
    : 0;
*/
  const totalImporte = Array.isArray(cartItems)
    ? cartItems.reduce(
      (total, item) => total + parseFloat(item.CarritoItemTotal || 0),
      0
    )
    : 0;
  const handleSelectPaymentMethod = (option) => {
    setFormValues((prev) => ({
      ...prev,
      paymentMethodCode: option.code,
      paymentMethodLabel: option.label || "",
      paymentMethodGroup: option.group || "",
    }));
  };

  const renderPaymentMethodPicker = () => {
    if (!usaMetodoPagoPersonalizado) return null;

    return (
      <Box sx={{ mb: 3 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          <strong>Método de Pago</strong>
        </Typography>

        {PAYMENT_CATEGORY_ORDER.map((categoryKey) => {
          const opcionesCategoria = customPaymentOptions.filter(
            (opt) => opt.category === categoryKey
          );
          if (opcionesCategoria.length === 0) return null;

          return (
            <Box key={categoryKey} sx={{ mb: 2.5 }}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 1, color: "text.secondary", fontWeight: 700 }}
              >
                {PAYMENT_CATEGORY_LABELS[categoryKey]}
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
                {opcionesCategoria.map((option) => {
                  const isSelected =
                    formValues?.paymentMethodCode === option.code;
                  const logoSrc = PAYMENT_LOGOS[option.code];
                  const brandColor =
                    BRAND_COLORS[option.code] || DEFAULT_BRAND_COLOR;
                  const logoZoom = LOGO_ZOOM[option.code] || 1;

                  return (
                    <Box
                      key={option.code}
                      onClick={() => handleSelectPaymentMethod(option)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleSelectPaymentMethod(option);
                        }
                      }}
                      sx={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 132,
                        height: 68,
                        p: 0.5,
                        borderRadius: 2,
                        border: "2px solid",
                        borderColor: isSelected ? "primary.main" : "transparent",
                        boxShadow: isSelected
                          ? "0 0 0 1px rgba(25,118,210,0.25)"
                          : "0 1px 2px rgba(0,0,0,0.12)",
                        cursor: "pointer",
                        transition: "border-color 0.15s ease, transform 0.15s ease",
                        "&:hover": {
                          borderColor: "primary.main",
                        },
                      }}
                    >
                      {logoSrc ? (
                        <Box
                          sx={{
                            width: "100%",
                            height: "100%",
                            borderRadius: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#fff",
                            overflow: "hidden",
                          }}
                        >
                          <Box
                            component="img"
                            src={logoSrc}
                            alt={option.label}
                            sx={{
                              width: "82%",
                              height: "82%",
                              objectFit: "contain",
                              transform: `scale(${logoZoom})`,
                            }}
                          />
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            width: "100%",
                            height: "100%",
                            borderRadius: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: brandColor,
                            color: "#fff",
                            fontWeight: 700,
                            fontSize: 12,
                            lineHeight: 1.15,
                            textAlign: "center",
                            px: 0.75,
                          }}
                        >
                          {option.label}
                        </Box>
                      )}

                      {isSelected && (
                        <CheckCircleIcon
                          sx={{
                            position: "absolute",
                            top: -8,
                            right: -8,
                            color: "primary.main",
                            backgroundColor: "#fff",
                            borderRadius: "50%",
                            fontSize: 18,
                          }}
                        />
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Box>
          );
        })}
      </Box>
    );
  };

  const handleCreateTransaction = async () => {
    if (creating) return;

    setCreating(true);
    try {
      localStorage.setItem("checkoutForm", JSON.stringify(formValues));
      localStorage.setItem("checkoutStep", JSON.stringify(1));

      const reservaMotorNro =
        typeof onBeforeWebpay === "function" ? await onBeforeWebpay() : null;

      if (!reservaMotorNro) {
        setCreating(false);
        return;
      }

      const urlBackend = await leerParametroURL("PAGO_GX18_MOTOR");
      const hotel = datosHotel.MotorHotAdmintour;
      const laSesion = session;
      const importe = totalImporte;
      const hotelEnElMotor = hotCod;

      const datoAEncriptar =
        hotel +
        "|" +
        laSesion +
        "|" +
        importe +
        "|" +
        hotelEnElMotor +
        "|" +
        reservaMotorNro;

      const encriptado = await enctriptoParaAdmintour(datoAEncriptar);

      const urlCompleta =
        urlBackend.UrlParametro.trim() +
        "?Encrypt64=" +
        encriptado.DatosEncriptado;

      window.location.href = urlCompleta;
    } catch (e) {
      console.error("No se pudo iniciar Webpay:", e);
      setCreating(false);
    }
  };

  //banco estado
  const handleCreateTransactionCompraAqui = async () => {
    if (creating) return;

    setCreating(true);

    try {
      localStorage.setItem("checkoutForm", JSON.stringify(formValues));
      localStorage.setItem("checkoutStep", JSON.stringify(1));
      localStorage.setItem("paymentType", "COMPRA_AQUI");

      const reservaMotorNro =
        typeof onBeforeWebpay === "function"
          ? await onBeforeWebpay()
          : null;

      if (!reservaMotorNro) {
        setCreating(false);
        return;
      }

      const urlBackend = await leerParametroURL("COMPRAAQUI_INICIO");

      const hotel = datosHotel.MotorHotAdmintour;
      const laSesion = session;

      // SOLO CAMBIA ESTO
      const importe = totalImporte * 0.5;

      const hotelEnElMotor = hotCod;

      const datosEnc = valorT;

      const datoAEncriptar =
        hotel +
        "|" +
        laSesion +
        "|" +
        importe +
        "|" +
        hotelEnElMotor +
        "|" +
        reservaMotorNro +
        "|" +
        datosEnc
        ;

      const encriptado = await enctriptoParaAdmintour(
        datoAEncriptar
      );

      const urlCompleta =
        urlBackend.UrlParametro.trim() +
        "?Encrypt64=" +
        encriptado.DatosEncriptado;

      window.location.href = urlCompleta;
    } catch (e) {
      console.error("No se pudo iniciar Compra Aqui:", e);
      setCreating(false);
    }
  };


  if (loading) {
    return <p>Cargando...</p>;
  }

  return (
    <>
      <Box>
        {usaMetodoPagoPersonalizado ? (
          <Box>
            {renderPaymentMethodPicker()}

            <FormControlLabel
              control={
                <Checkbox
                  checked={aceptaTerminosTransferencia}
                  onChange={(e) =>
                    setAceptaTerminosTransferencia(e.target.checked)
                  }
                />
              }
              label="Acepto los términos y políticas de reserva del hotel"
            />

            {esHotelChile && (
              <>
                <Box
                  onClick={() =>
                    setMostrarDatosPersonales(!mostrarDatosPersonales)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "fit-content",
                    mt: 1,
                    mb: 2,
                  }}
                >
                  <Typography sx={{ mr: 1 }}>
                    Ver política de protección de datos personales
                  </Typography>
                  {mostrarDatosPersonales ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </Box>

                <Collapse in={mostrarDatosPersonales}>
                  <Box
                    sx={{
                      backgroundColor: "#f0f0f0",
                      padding: 2,
                      borderRadius: 2,
                      maxHeight: 200,
                      overflowY: "auto",
                      mb: 3,
                    }}
                  >
                    <Typography variant="body2">
                      {datosHotel.MotorHotDatosPersonales}
                    </Typography>
                  </Box>
                </Collapse>
              </>
            )}

            <Box
              onClick={() => setMostrarNormas(!mostrarNormas)}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                width: "fit-content",
                mb: 3,
              }}
            >
              <Typography sx={{ fontWeight: "bold", mr: 1 }}>
                Ver normas del hotel
              </Typography>
              {mostrarNormas ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={mostrarNormas}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  borderRadius: 2,
                  maxHeight: 200,
                  overflowY: "auto",
                }}
              >
                <Typography variant="body2">
                  {datosHotel.Condiciones}
                </Typography>
              </Box>
            </Collapse>
          </Box>
        ) : tarjetaEnGarantia === "S" ? (
          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={aceptaTerminos}
                  onChange={(e) => setAceptaTerminos(e.target.checked)}
                />
              }
              label={
                <Typography variant="body2">
                  Acepto los{" "}
                  <Link
                    component="button"
                    variant="body2"
                    underline="always"
                    onClick={() => setOpenDialog(true)}
                  >
                    términos y políticas de reserva del hotel
                  </Link>
                </Typography>
              }
            />

            <Box
              onClick={() => setMostrarDatosPersonales(!mostrarDatosPersonales)}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                mt: 1,
                width: "fit-content",
              }}
            >
              <Typography sx={{ mr: 1 }}>
                Ver política de protección de datos personales
              </Typography>
              {mostrarDatosPersonales ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={mostrarDatosPersonales}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  borderRadius: 2,
                  maxHeight: 200,
                  overflowY: "auto",
                }}
              >
                <Typography variant="body2">
                  {datosHotel.MotorHotDatosPersonales}
                </Typography>
              </Box>
            </Collapse>

            <Box
              sx={{
                mb: 3,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                onClick={handleCreateTransaction}
                disabled={!aceptaTerminos || transactionLoading}
                sx={{
                  backgroundColor: "white",
                  borderRadius: 2,
                  padding: 1.5,
                  boxShadow: 3,
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    transform: "scale(1.03)",
                    boxShadow: 6,
                    backgroundColor: "white",
                  },
                  opacity: aceptaTerminos ? 1 : 0.5,
                }}
              >
                <Box
                  component="img"
                  src={webpay}
                  alt="Pagar con Webpay"
                  sx={{
                    width: { xs: "100%", sm: "260px" },
                    maxWidth: "100%",
                    height: "auto",
                  }}
                />
              </Button>
            </Box>
          </Box>
        ) : tarjetaEnGarantia === "B" ? (
          <Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Seleccione el método de pago</strong>
            </Typography>

            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                p: 2,
                mb: 3,
                backgroundColor: "#fafafa",
              }}
            >
              <FormControl fullWidth>
                <RadioGroup
                  value={tipoPagoGarantiaB}
                  onChange={(e) => {
                    setTipoPagoGarantiaB(e.target.value);

                    setAceptaTerminosTransferencia(false);

                    setFormValues({
                      ...formValues,
                      paymentType: e.target.value,
                    });
                  }}
                >
                  <FormControlLabel
                    value="COMPRA_AQUI"
                    control={<Radio />}
                    label="Compra Aquí (50% de la reserva)"
                  />

                  <FormControlLabel
                    value="RECINTO"
                    control={<Radio />}
                    label="Pago en recinto"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={aceptaTerminosTransferencia}
                  onChange={(e) =>
                    setAceptaTerminosTransferencia(e.target.checked)
                  }
                />
              }
              label={
                <Typography variant="body2">
                  Acepto los{" "}
                  <Link
                    component="button"
                    variant="body2"
                    underline="always"
                    onClick={() => setOpenDialog(true)}
                  >
                    términos y políticas de reserva del hotel
                  </Link>
                </Typography>
              }
            />

            <Box
              onClick={() => setMostrarDatosPersonales(!mostrarDatosPersonales)}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                mt: 1,
                width: "fit-content",
              }}
            >
              <Typography sx={{ mr: 1 }}>
                Ver política de protección de datos personales
              </Typography>
              {mostrarDatosPersonales ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={mostrarDatosPersonales}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  borderRadius: 2,
                  maxHeight: 200,
                  overflowY: "auto",
                }}
              >
                <Typography variant="body2">
                  {datosHotel.MotorHotDatosPersonales}
                </Typography>
              </Box>
            </Collapse>

            {tipoPagoGarantiaB === "COMPRA_AQUI" && (
              <Box
                sx={{
                  mb: 3,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  onClick={handleCreateTransactionCompraAqui}
                  disabled={!aceptaTerminosTransferencia || transactionLoading}
                  sx={{
                    backgroundColor: "white",
                    borderRadius: 2,
                    padding: 1.5,
                    boxShadow: 3,
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    "&:hover": {
                      transform: "scale(1.03)",
                      boxShadow: 6,
                      backgroundColor: "white",
                    },
                    opacity: aceptaTerminosTransferencia ? 1 : 0.5,
                  }}
                >
                  <Box
                    component="img"
                    src={compraaqui}
                    alt="Pagar con Compra Aquí"
                    sx={{
                      width: { xs: "100%", sm: "260px" },
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                </Button>
              </Box>
            )}
          </Box>
        ) : aceptaTransferencia ? (
          <Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>El medio de pago es Transferencia Bancaria</strong>
            </Typography>

            <Typography variant="body1" sx={{ mt: 2 }}>
              <strong>Datos para la transferencia:</strong>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Banco:</strong> {datosHotel.Banco}
            </Typography>
            <Typography variant="body2">
              <strong>Número de cuenta:</strong> {datosHotel.CuentaBanco}
            </Typography>
            <Typography variant="body2">
              <strong>Alias:</strong> {datosHotel.aliascuenta}
            </Typography>
            <Typography variant="body2" sx={{ mb: 3 }}>
              <strong>Contacto para enviar comprobante:</strong>{" "}
              {datosHotel.Contacto}
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={aceptaTerminosTransferencia}
                  onChange={(e) =>
                    setAceptaTerminosTransferencia(e.target.checked)
                  }
                />
              }
              label="Acepto los términos y políticas de reserva del hotel"
            />

            {esHotelChile && (
              <>
                <Box
                  onClick={() =>
                    setMostrarDatosPersonales(!mostrarDatosPersonales)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "fit-content",
                    mt: 1,
                    mb: 2,
                  }}
                >
                  <Typography sx={{ mr: 1 }}>
                    Ver política de protección de datos personales
                  </Typography>
                  {mostrarDatosPersonales ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </Box>

                <Collapse in={mostrarDatosPersonales}>
                  <Box
                    sx={{
                      backgroundColor: "#f0f0f0",
                      padding: 2,
                      borderRadius: 2,
                      maxHeight: 200,
                      overflowY: "auto",
                      mb: 3,
                    }}
                  >
                    <Typography variant="body2">
                      {datosHotel.MotorHotDatosPersonales}
                    </Typography>
                  </Box>
                </Collapse>
              </>
            )}

            <Box
              onClick={() => setMostrarNormas(!mostrarNormas)}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                width: "fit-content",
                mb: 3,
              }}
            >
              <Typography sx={{ fontWeight: "bold", mr: 1 }}>
                Ver normas del hotel
              </Typography>
              {mostrarNormas ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={mostrarNormas}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  borderRadius: 2,
                  maxHeight: 200,
                  overflowY: "auto",
                }}
              >
                <Typography variant="body2">
                  {datosHotel.Condiciones}
                </Typography>
              </Box>
            </Collapse>
          </Box>
        ) : (
          <Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>
                Este hotel no requiere un pago anticipado para confirmar la
                reserva.
              </strong>
            </Typography>

            <Typography variant="body2" sx={{ mb: 3 }}>
              El pago de su estadía se realizará directamente en el
              establecimiento, según las políticas del hotel.
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={aceptaTerminosTransferencia}
                  onChange={(e) =>
                    setAceptaTerminosTransferencia(e.target.checked)
                  }
                />
              }
              label="Acepto los términos y políticas de reserva del hotel"
            />

            {esHotelChile && (
              <>
                <Box
                  onClick={() =>
                    setMostrarDatosPersonales(!mostrarDatosPersonales)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "fit-content",
                    mt: 1,
                    mb: 2,
                  }}
                >
                  <Typography sx={{ mr: 1 }}>
                    Ver política de protección de datos personales
                  </Typography>
                  {mostrarDatosPersonales ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </Box>

                <Collapse in={mostrarDatosPersonales}>
                  <Box
                    sx={{
                      backgroundColor: "#f0f0f0",
                      padding: 2,
                      borderRadius: 2,
                      maxHeight: 200,
                      overflowY: "auto",
                      mb: 3,
                    }}
                  >
                    <Typography variant="body2">
                      {datosHotel.MotorHotDatosPersonales}
                    </Typography>
                  </Box>
                </Collapse>
              </>
            )}

            <Box
              onClick={() => setMostrarNormas(!mostrarNormas)}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                width: "fit-content",
                mb: 3,
              }}
            >
              <Typography sx={{ fontWeight: "bold", mr: 1 }}>
                Ver normas del hotel
              </Typography>
              {mostrarNormas ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            <Collapse in={mostrarNormas}>
              <Box
                sx={{
                  backgroundColor: "#f0f0f0",
                  padding: 2,
                  borderRadius: 2,
                  maxHeight: 200,
                  overflowY: "auto",
                }}
              >
                <Typography variant="body2">
                  {datosHotel.Condiciones}
                </Typography>
              </Box>
            </Collapse>
          </Box>
        )}
      </Box>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="sm"
        fullWidth
        fullScreen={fullScreen}
      >
        <DialogTitle sx={{ m: 0, p: 2, position: "relative" }}>
          Términos y políticas de reserva del hotel
          <IconButton
            aria-label="close"
            onClick={() => setOpenDialog(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
            {datosHotel.Condiciones || "No se han definido condiciones."}
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Payment;